var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("transition", [
        _c("div", {
          staticClass: "color-filter",
          class: [_vm.bemAdd(_vm.cssName)]
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe07b7f8", { render: render, staticRenderFns: staticRenderFns })
  }
}